export default [
    {
        path: '/deposit/order',
        component: (resolve) => require(['@/components/deposit/Order'], resolve),
        meta: {
            title: '支付页面',
            default: '/course/Detail',   //默认返回
            multiple: true,     //是否为多入口页面
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/deposit.js